export const Sheet_Url="https://script.google.com/macros/s/AKfycbyBVZ_BQWaHhhoOnSXorqBrGa6luENzOmHJ2tijbcLOefDVwat7sG2qCIGp8beuTgTd/exec";
export const MANDATORY_FIELD_ERROR = "Câmp obligatoriu";
export const EMAILJS_CONFIG = {
    templateId: 'template_v4lv5oq',
    serviceId: 'service_y2nua26',
    publickKey: 'TaRRGjTtFdEY5wbpV'
}